module.exports = __webpack_public_path__ + "static/mobile_app_development-189ed4887b69493a078fd69545e850eb.jpg";